import React, { useEffect, useState } from "react";
import { FiEdit } from "react-icons/fi";
import Select from "react-select";
import { Cookies } from '../../index.js';
import { alert_error, alert_success } from '../../AppContext';
import axios from 'axios';

function Editor({ item, contact, setcontact, showditor, setshowditor }) {
    const [options, setoptions] = useState([
        {
            id: '1', stt: '', name: 'Ấn link',
            money: '', status: 'show', content: '', value: 'link_ref'
        },
        {
            id: '2', stt: '', name: 'Nhập mã',
            money: '', status: 'show', content: '', value: 'promo_code'
        }
    ]);
    const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
    const [nutxuly, setnutxuly] = useState(0);
    const [price, setprice] = useState('');
    const [time, settime] = useState('');
    const [guide, setguide] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    const [isOpen, setIsOpen] = useState(false);
    const [category, setcategory] = useState('');
    const [name_category, setname_category] = useState('');
    const [selectedOption, setSelectedOption] = useState(''); // Chọn giá trị ban đầu

    const handleOptionChange = (selectedOption) => {
        setIsOpen(false);
        if (selectedOption) {
            const selectedValue = selectedOption.value;
            setcategory(selectedValue);
            const selectedOptionOk = options.find((option) => option.servicecode === selectedValue);
            // Add other actions here based on the user's selection
        }
    };
    const handleFocus = () => {
        setIsOpen(true);
        console.log(123);
    };
    const handleBlur = () => {
        setIsOpen(false);
    };
    const handleMenuOpen = () => {
        setIsOpen(true);
    };

    const exitedit = () => {
        setshowditor(false);
    };
    const checkedit = () => {
        if (item) {
            if (item.price) {
                setprice(item.price);
                settime(item.time);
                setguide(item.guide);
                if (item.category) {
                    if (item.category == 'link_ref') {

                    }
                    else if (item.category == 'link_ref') {

                    }

                }
            }
        }
    };
    function handleSubmit(event) {
        setnutxuly(1);
        const apikey = Cookies.get('apikey');
        event.preventDefault();
        setnutorder('Please wait a moment 😊');
        if (!contact) {
            alert_error('Please điền đầy đủ thông tin')
            setnutxuly(0);
            setnutorder('điền đủ thông tin');
            return
        }
        axios
            .get('https://hust.media/jop/mission/infotask_editor.php', {
                params: {
                    apikey: apikey,
                    contact: contact
                }
            })
            .then(
                response => (testFunction(response))
            )
            .catch(error => console.log(error))

    };
    function testFunction(response) {
        setnutxuly(0);
        const info = response.data;
        const status = info.status;
        const message = info.message;
        setnutorder('đặt tiếp luôn nào')
        if (status == 0) {
            alert_error(info.message);
        }
        else if (status == 1) {
            alert_success(info.message);
        }
        if (info.redirect != null && info.redirect != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirect;
            }, 1700);
        }
    };
    useEffect(() => {
        // embedtele();
        checkedit();
    }, []);
    return (
        <>
            {
                showditor &&
                (
                    <>
                        <form className="mx-2 mt-1 add-form">
                            <div className="form-control">
                                <div className='flex items-center justify-between flex-1'>
                                    <label className="mb-2 text-lg">Chỉnh sửa thông tin quản lý
                                        {item && (<>  {item.id}</>)}
                                    </label>
                                    <label onClick={exitedit} className="mb-2 px-2 ">Đóng</label>
                                </div>

                                <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping">
                                        Link <br /> Liên hệ
                                    </span>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Điền link người dùng liên hệ với bạn"
                                        aria-label="inputlienket"
                                        value={contact}
                                        name="inputlienket"
                                        aria-describedby="addon-wrapping"
                                        onChange={e => setcontact(e.target.value)}
                                    />
                                </div>
                                {/* <div className="input-group flex-nowrap">
                                    <span className="input-group-text" id="addon-wrapping">
                                        App pay
                                    </span>
                                    <input
                                        type="number"
                                        className="form-control"
                                        placeholder="Số tiền app trả cho giới thiệu 1 người dùng"
                                        aria-label="inputlienket"
                                        value={price}
                                        name="inputlienket"
                                        aria-describedby="addon-wrapping"
                                        onChange={e => setprice(e.target.value)}
                                    />
                                </div> */}

                                <button disabled={nutxuly == 1} onClick={handleSubmit}
                                    className='mt-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-3 w-full dark:bg-slate-800 dark:text-white'>
                                    <div className='flex items-center justify-between flex-1'>
                                        {nutxuly == 1 &&
                                            <div className="spinner-border" role="status">

                                            </div>}


                                        <span className='text-lg font-medium text-white'>
                                            {nutorder} </span>
                                            <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                                    </div>
                                </button>
                            </div>
                        </form>
                    </>
                )
            }
        </>
    );
}

export default Editor;
